
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function singleVehicleGarageRT () {
    return _createElement('div', { 'className': 'garage-container' }, [this.changeButton(function () {
            return _createElement('div', { 'className': 'cm_changeButton' }, _createElement('svg', {
                'width': '18',
                'height': '17',
                'viewBox': '0 0 18 17',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg'
            }, _createElement('path', {
                'd': 'M4.74609 3.39844L3.83203 6H14.1328L13.2188 3.39844C13.0781 2.94141 12.6562 2.625 12.1641 2.625H5.80078C5.30859 2.625 4.88672 2.94141 4.74609 3.39844ZM1.37109 6.17578L2.60156 2.66016C3.09375 1.28906 4.35938 0.375 5.80078 0.375H12.1641C13.6055 0.375 14.8711 1.28906 15.3633 2.66016L16.5938 6.17578C17.4023 6.52734 18 7.33594 18 8.25V13.3125V15C18 15.6328 17.4727 16.125 16.875 16.125H15.75C15.1172 16.125 14.625 15.6328 14.625 15V13.3125H3.375V15C3.375 15.6328 2.84766 16.125 2.25 16.125H1.125C0.492188 16.125 0 15.6328 0 15V13.3125V8.25C0 7.33594 0.5625 6.52734 1.37109 6.17578ZM4.5 9.375C4.5 8.77734 3.97266 8.25 3.375 8.25C2.74219 8.25 2.25 8.77734 2.25 9.375C2.25 10.0078 2.74219 10.5 3.375 10.5C3.97266 10.5 4.5 10.0078 4.5 9.375ZM14.625 10.5C15.2227 10.5 15.75 10.0078 15.75 9.375C15.75 8.77734 15.2227 8.25 14.625 8.25C13.9922 8.25 13.5 8.77734 13.5 9.375C13.5 10.0078 13.9922 10.5 14.625 10.5Z',
                'fill': 'white'
            })), this.template === 'active' ? _createElement('div', {
                'className': 'active-container cmTemplate_active',
                'key': '1076'
            }, window.Convermax.config?.selectYourVehicleTitle || 'Select Your Vehicle') : null, this.template === 'locked' ? _createElement('div', {
                'className': 'locked-container cmTemplate_locked',
                'key': '1264'
            }, _createElement('span', { 'className': 'model' }, this.vehicleString), _createElement('span', { 'className': 'change' }, 'Change')) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], this.template === 'locked' ? _createElement('div', {
        'className': 'clear-garage cmTemplate_locked',
        'key': '2176'
    }, _createElement('div', {
        'className': 'cm_button',
        'data-cm-role': 'discard-vehicle'
    }, _createElement('span', {}, 'Clear'))) : null);
}
        export const componentNames = ["cm:changeButton"]